import { send } from "./api.js";
import type { LessonResourceMatch } from "./LessonResourceEditor.js";

/** New instruments can supply their own provider without changing the editor. */
export async function addLessonResource(context: "private" | "school", targetId: string, resource: LessonResourceMatch, idempotencyKey: string): Promise<{ title: string; href: string }> {
  const target = encodeURIComponent(targetId);
  const path = resource.kind === "groove"
    ? context === "private" ? `/grooves/lessons/${target}/grooves/quick-add`
      : `/school-domain/lesson-workspace/notes/${target}/grooves/quick-add`
    : `/lesson-resources/${context}/${target}/assets`;
  const repertoire = resource.repertoireId ? { repertoireId: resource.repertoireId } : {};
  return send("POST", path, resource.kind === "groove" ? { grooveId: resource.id, ...repertoire } : { kind: resource.kind, id: resource.id, ...repertoire }, { "Idempotency-Key": idempotencyKey });
}
